export const LIST_TICKET_SEAT = "LIST_TICKET_SEAT";
export const UPDATE_TICKET_SEAT = "UPDATE_TICKET_SEAT";
export const DELETE_TICKET_SEAT = "DELETE_TICKET_SEAT";
export const CHANGE_CHECK_IN = "CHANGE_CHECK_IN";
export const CHECK_IN_TICKET_SEAT = "CHECK_IN_TICKET_SEAT";
export const IMPORT_TICKET_SEAT = "IMPORT_TICKET_SEAT";
export const EXPORT_TICKET_SEAT = "EXPORT_TICKET_SEAT";
export const SHOW_TICKET_SEAT = "SHOW_TICKET_SEAT";
export const DOWNLOAD_TEMPLATE_TICKET_SEAT = "DOWNLOAD_TEMPLATE_TICKET_SEAT";
